import React  from 'react';

import gwzrjsrxdfps from '../assets/img/gwzrjsrxdfps.png';

const Enclosure315 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div>
            <img src={gwzrjsrxdfps} alt="" style={{
                width  : '80%',
                display: 'block',
                margin : '0 auto'
            }}/>
            
            <br/><br/>
        </div>
    </div>



export default Enclosure315;